// extracted by css-extract-rspack-plugin
export default {"seo":"lfh40","picture":"NujG3","white-60":"CUTLW","white60":"CUTLW","white-80":"WWGN1","white80":"WWGN1"};